import React from 'react';
import { policeMonthYearInput } from '../utils/date';
import BaseDateField from './BaseDateField';

const MonthYearField = props => {
  return <BaseDateField {...props} validationFn={policeMonthYearInput} />;
};

export default MonthYearField;
